import { render, staticRenderFns } from "./Bid.vue?vue&type=template&id=0b9cf54f&scoped=true"
import script from "./Bid.vue?vue&type=script&lang=js"
export * from "./Bid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9cf54f",
  null
  
)

export default component.exports